export const openThreeDWelcomePopup = () => ({
    type: 'OPEN_THREED_WELCOME_POPUP',
})

export const closeThreeDWelcomePopup = () => ({
    type: 'CLOSE_THREED_WELCOME_POPUP',
})